module.exports = __webpack_public_path__ + "img/801-2f048f.png";